import React, { Component } from "react";
//import SettingMenu from "../Shared/SettingMenu";
import { Row, Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
// import BarApexChart from "../AllCharts/apex/barchart";
// import StackedBarChart from "../AllCharts/apex/stackedbarchart";
import { Bar } from "react-chartjs-2";
import { Progress } from "reactstrap";
import ReactApexChart from "react-apexcharts";
// import Vector from "../Maps/Vectormap";
import { VectorMap } from "react-jvectormap";
import "../../assets/scss/custom.scss";
import { withTranslation } from "react-i18next";
import i18next from "i18next";
import { MetaTags } from "react-meta-tags";
import "chartist/dist/scss/chartist.scss";
import { Sugar } from "react-preloaders";
import config from "./../../helpers/Constants";
import PulseLoader from "react-spinners/ClipLoader";
import { ThemeContext } from "../../ThemeContext";

const progressBar = {
  height: "5px",
};
const countryName = {
  float: "left",
};
const countryCount = {
  float: "right",
};

const countryLine = {
  display: "flow-root",
  marginBottom: "0px",
};

class Dashboard extends Component {
  static contextType = ThemeContext;
  constructor(props) {
    super(props);
    //this.state = {};
    this.state = {
      value: localStorage.getItem("lang"),
      diag_ac_user_count: 0,
      diagnosis_count: 0,
      ver_ac_user_count: 0,
      ver_count: 0,
      diag_brand_list: [],
      diag_brand_item: [],
      diag_model_list: [],
      diag_model_item: [],
      diag_ecu_list: [],
      diag_ecu_item: [],
      diag_lang_list: [],
      diag_lang_item: [],
      diag_location_count: [],
      diag_location_array: [],
      ver_location_array: [],
      ver_location_count: [],
      diag_tester_list: [],
      diag_tester_item: [],
      ver_tester_list: [],
      ver_tester_item: [],
      ver_lang_list: [],
      ver_lang_item: [],
      ver_ac_password: 0,
      ver_exp_password: 0,
      ver_tester_undefined_div: 0,
      ver_tester_android_div: 0,
      ver_tester_windows_div: 0,
      ver_tester_ap_undefined_div: 0,
      ver_tester_ap_android_div: 0,
      ver_tester_ap_windows_div: 0,
      ver_tester_total_div: 0,
      ver_tester_ap_total_div: 0,
      ver_tester_undefined_ione: 0,
      ver_tester_android_ione: 0,
      ver_tester_windows_ione: 0,
      ver_tester_total_ione: 0,
      ver_tester_ap_undefined_ione: 0,
      ver_tester_ap_android_ione: 0,
      ver_tester_ap_windows_ione: 0,
      ver_tester_ap_total_ione: 0,
      daysvalue: localStorage.getItem("data_visible_days"),
      diag_au_daysvalue: "",
      diag_daysvalue: "",
      diag_brands_daysvalue: "",
      diag_models_daysvalue: "",
      diag_lang_daysvalue: "",
      diag_ecu_daysvalue: "",
      diag_map_daysvalue: "",
      diag_tester_daysvalue: "",
      ver_au_daysvalue: "",
      ver_daysvalue: "",
      ver_map_daysvalue: "",
      ver_tester_daysvalue: "",
      ver_tester_d_daysvalue: "",
      ver_tester_ap_daysvalue: "",
      ver_ap_daysvalue: "",
      ver_lang_daysvalue: "",
      loading: true,
      tabledataloading: false,
      sum_ac_user_count: 0,
      sum_au_daysvalue: "",
      sum_ac_password: 0,
      sum_exp_password: 0,
      sum_ap_daysvalue: "",
      sum_all_ac_password: 0,
      sum_all_exp_password: 0,
      sum_all_ap_daysvalue: "",
      sum_os_windows: 0,
      sum_os_android: 0,
      sum_os_undefined: 0,
      sum_os_daysvalue: "",
      sum_all_ap_total: 0,
      sum_os_total: 0,
    };
    i18next.changeLanguage(localStorage.getItem("lang"));
    this.handleDiagAcUserBarChange = this.handleDiagAcUserBarChange.bind(this);
    this.handleDiagBarChange = this.handleDiagBarChange.bind(this);
    this.handleDiagBrandBarChange = this.handleDiagBrandBarChange.bind(this);
    this.handleDiagModelBarChange = this.handleDiagModelBarChange.bind(this);
    this.handleDiagEcuBarChange = this.handleDiagEcuBarChange.bind(this);
    this.handleDiagLangBarChange = this.handleDiagLangBarChange.bind(this);
    this.handleDiagLocationBarChange =
      this.handleDiagLocationBarChange.bind(this);
    this.handleDiagTesterBarChange = this.handleDiagTesterBarChange.bind(this);
    this.handleVerAcUserBarChange = this.handleVerAcUserBarChange.bind(this);
    this.handleVerBarChange = this.handleVerBarChange.bind(this);
    this.handleVerLangBarChange = this.handleVerLangBarChange.bind(this);
    this.handleVerApBarChange = this.handleVerApBarChange.bind(this);
    this.handleVerLocationBarChange =
      this.handleVerLocationBarChange.bind(this);
    this.handleVerTesterBarChange = this.handleVerTesterBarChange.bind(this);
    this.handleVerTesterDisBarChange =
      this.handleVerTesterDisBarChange.bind(this);
    this.handleVerTesterDisApBarChange =
      this.handleVerTesterDisApBarChange.bind(this);
    this.handleSumActUserBarChange = this.handleSumActUserBarChange.bind(this);
    this.handleSumApBarChange = this.handleSumApBarChange.bind(this);
    this.handleSumAllApBarChange = this.handleSumAllApBarChange.bind(this);
    this.handleSumOSBarChange = this.handleSumOSBarChange.bind(this);
  }

  componentDidMount() {
    let decodedString = localStorage.getItem("authUser");
    let authUser = JSON.parse(atob(decodedString));
    var user_id = authUser.id;
    //console.log(user_id);
    var data_visible_days = localStorage.getItem("data_visible_days");
    const user_language = localStorage.getItem("user_db_lang");

    this.setState({
      diag_au_daysvalue: data_visible_days,
      diag_daysvalue: data_visible_days,
      diag_brands_daysvalue: data_visible_days,
      diag_map_daysvalue: data_visible_days,
      diag_tester_daysvalue: data_visible_days,
      ver_au_daysvalue: data_visible_days,
      ver_daysvalue: data_visible_days,
      ver_map_daysvalue: data_visible_days,
      ver_tester_daysvalue: data_visible_days,
      ver_tester_d_daysvalue: data_visible_days,
      ver_tester_ap_daysvalue: data_visible_days,
      ver_ap_daysvalue: data_visible_days,
      ver_lang_daysvalue: data_visible_days,
      diag_models_daysvalue: data_visible_days,
      diag_lang_daysvalue: data_visible_days,
      diag_ecu_daysvalue: data_visible_days,
      sum_au_daysvalue: data_visible_days,
      sum_ap_daysvalue: data_visible_days,
      sum_all_ap_daysvalue: data_visible_days,
      sum_os_daysvalue: data_visible_days,
    });

    if (!data_visible_days) {
      var day = "14";
    } else {
      day = data_visible_days;
    }

    const selected_product = localStorage.getItem("sel_product");
    const data_source = localStorage.getItem("data_source");
    if (!selected_product) {
      var sel_product = "all";
    } else {
      var sel_product = selected_product;
    }

    fetch(config.API + "get_user_permissions/" + user_id, {
      headers: {
        Nexion_API_Key: config.API_KEY,
      },
    })
      .then((Responses) => Responses.json())
      .then((findresponses) => {
        //console.log(findresponses);
        // this.setState({
        //   loading: false,
        // });
        if (findresponses.users === 0) {
          window.history.back();
        }
      });

    //diag active users
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_active_users/";
    } else {
      var data_source_final = "get_dashboard_active_users/";
    }

    fetch(
      config.API +
        // "get_dashboard_active_users/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse);
        this.setState({
          diag_ac_user_count: findresponse.diag_count,
        });
      });

    //diagnosis count
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_diagnosis/";
    } else {
      var data_source_final = "get_dashboard_diagnosis/";
    }

    var days = localStorage.getItem("data_visible_days");
    var diagnosis_count;
    fetch(
      config.API +
        // "get_dashboard_diagnosis/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        diagnosis_count = findresponse.diag_count;
        this.setState({
          diag_count: findresponse.diag_count,
        });
      })
      .then(() => {
        //diagnosis location count
        var days = localStorage.getItem("data_visible_days");
        if (data_source === "internal") {
          var data_source_final = "test_get_dashboard_diagnosis_location/";
        } else {
          var data_source_final = "get_dashboard_diagnosis_location/";
        }

        fetch(
          config.API +
            // "get_dashboard_diagnosis_location/" +
            data_source_final +
            day +
            "?company=Nexion&sel_product=" +
            sel_product +
            "&user_lang=" +
            user_language,
          {
            headers: {
              Nexion_API_Key: config.API_KEY,
            },
          }
        )
          .then((Response) => Response.json())
          .then((findresponse) => {
            var old_total_count = findresponse
              .map((item) => item.diagnosis_count)
              .reduce((prev, next) => prev + next, 0);

            let diag_undef = diagnosis_count - old_total_count;
            let new_loc_array = {
              diagnosis_count: diag_undef,
              country_name: "Undefined",
            };
            findresponse.push(new_loc_array);

            var new_total_count = findresponse
              .map((item) => item.diagnosis_count)
              .reduce((prev, next) => prev + next, 0);

            this.setState({
              diag_location_count: new_total_count,
              diag_map_daysvalue: days,
              diag_location_array: findresponse,
            });
          });
      });

    //diagnosis brands
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_diagnosis_brands/";
    } else {
      var data_source_final = "get_dashboard_diagnosis_brands/";
    }

    fetch(
      config.API +
        // "get_dashboard_diagnosis_brands/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse);
        this.setState({
          diag_brand_list: findresponse.brands.b_list,
          diag_brand_item: findresponse.brands.b_items,
        });
      });

    //diagnosis Models
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_diagnosis_models/";
    } else {
      var data_source_final = "get_dashboard_diagnosis_models/";
    }

    fetch(
      config.API +
        // "get_dashboard_diagnosis_models/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse);
        this.setState({
          diag_model_list: findresponse.models.b_list,
          diag_model_item: findresponse.models.b_items,
        });
      });

    //diagnosis Ecus
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_diagnosis_ecu/";
    } else {
      var data_source_final = "get_dashboard_diagnosis_ecu/";
    }

    fetch(
      config.API +
        // "get_dashboard_diagnosis_ecu/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&lang=" +
        localStorage.getItem("lang") +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse);
        this.setState({
          diag_ecu_list: findresponse.models.b_list,
          diag_ecu_item: findresponse.models.b_items,
        });
      });

    //diagnosis Lang
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_diagnosis_lang/";
    } else {
      var data_source_final = "get_dashboard_diagnosis_lang/";
    }

    fetch(
      config.API +
        // "get_dashboard_diagnosis_lang/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse);
        this.setState({
          diag_lang_list: findresponse.languages.b_list,
          diag_lang_item: findresponse.languages.b_items,
        });
      });

    //Version Lang
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_lang/";
    } else {
      var data_source_final = "get_dashboard_version_lang/";
    }

    fetch(
      config.API +
        // "get_dashboard_version_lang/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse);
        this.setState({
          ver_lang_list: findresponse.languages.b_list,
          ver_lang_item: findresponse.languages.b_items,
        });
      });

    //Version Active Password
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_ap/";
    } else {
      var data_source_final = "get_dashboard_version_ap/";
    }

    fetch(
      config.API +
        // "get_dashboard_version_ap/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        this.setState({
          ver_ac_password: findresponse.ac_password,
          ver_exp_password: findresponse.exp_password,
        });
      });

    //version count
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_versions/";
    } else {
      var data_source_final = "get_dashboard_versions/";
    }

    var version_count;
    fetch(
      config.API +
        // "get_dashboard_versions/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        version_count = findresponse.ver_count;
        this.setState({
          ver_count: findresponse.ver_count,
        });
      })
      .then(() => {
        //version location count
        if (data_source === "internal") {
          var data_source_final = "test_get_dashboard_version_location/";
        } else {
          var data_source_final = "get_dashboard_version_location/";
        }

        fetch(
          config.API +
            // "get_dashboard_version_location/" +
            data_source_final +
            day +
            "?company=Nexion&sel_product=" +
            sel_product +
            "&user_lang=" +
            user_language,
          {
            headers: {
              Nexion_API_Key: config.API_KEY,
            },
          }
        )
          .then((Response) => Response.json())
          .then((findresponse) => {
            var old_total_count = findresponse
              .map((item) => item.diagnosis_count)
              .reduce((prev, next) => prev + next, 0);

            let ver_undef = version_count - old_total_count;
            let new_loc_array = {
              diagnosis_count: ver_undef,
              country_name: "Undefined",
            };
            findresponse.push(new_loc_array);

            var new_total_count = findresponse
              .map((item) => item.diagnosis_count)
              .reduce((prev, next) => prev + next, 0);

            this.setState({
              ver_location_count: new_total_count,
              ver_map_daysvalue: days,
              ver_location_array: findresponse,
            });
          });
      });

    //version ac user count
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_active_users/";
    } else {
      var data_source_final = "get_dashboard_version_active_users/";
    }

    fetch(
      config.API +
        // "get_dashboard_version_active_users/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        // console.log(findresponse);
        this.setState({
          ver_ac_user_count: findresponse.ver_count,
        });
      });

    //Diagnosis Tester
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_diagnosis_tester/";
    } else {
      var data_source_final = "get_dashboard_diagnosis_tester/";
    }

    fetch(
      config.API +
        // "get_dashboard_diagnosis_tester/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        // console.log(findresponse);
        this.setState({
          diag_tester_list: findresponse.testers.t_list,
          diag_tester_item: findresponse.testers.t_items,
        });
      });

    //Version Tester
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_tester/";
    } else {
      var data_source_final = "get_dashboard_version_tester/";
    }

    fetch(
      config.API +
        // "get_dashboard_version_tester/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        // console.log(findresponse);
        this.setState({
          ver_tester_list: findresponse.testers.t_list,
          ver_tester_item: findresponse.testers.t_items,
        });
      });

    //Version Tester Div.0 distribution
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_tester_os_div/";
    } else {
      var data_source_final = "get_dashboard_version_tester_os_div/";
    }

    fetch(
      config.API +
        // "get_dashboard_version_tester_os_div/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse[2].total);

        if (findresponse[0].total) {
          this.setState({
            ver_tester_undefined_div: findresponse[0].total,
          });
        } else {
          this.setState({
            ver_tester_undefined_div: 0,
          });
        }

        if (findresponse[1].total) {
          this.setState({
            ver_tester_android_div: findresponse[1].total,
          });
        } else {
          this.setState({
            ver_tester_android_div: 0,
          });
        }

        if (findresponse[2].total) {
          this.setState({
            ver_tester_windows_div: findresponse[2].total,
          });
        } else {
          this.setState({
            ver_tester_windows_div: 0,
          });
        }
        this.setState({
          ver_tester_total_div:
            findresponse[0].total +
            findresponse[1].total +
            findresponse[2].total,
        });
      });

    //Version Tester iONE Cruiser distribution
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_tester_os_ione/";
    } else {
      var data_source_final = "get_dashboard_version_tester_os_ione/";
    }

    fetch(
      config.API +
        // "get_dashboard_version_tester_os_ione/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        if (findresponse[0].total) {
          this.setState({
            ver_tester_undefined_ione: findresponse[0].total,
          });
        } else {
          this.setState({
            ver_tester_undefined_ione: 0,
          });
        }

        if (findresponse[1].total) {
          this.setState({
            ver_tester_android_ione: findresponse[1].total,
          });
        } else {
          this.setState({
            ver_tester_android_ione: 0,
          });
        }

        if (findresponse[2].total) {
          this.setState({
            ver_tester_windows_ione: findresponse[2].total,
          });
        } else {
          this.setState({
            ver_tester_windows_ione: 0,
          });
        }
        this.setState({
          ver_tester_total_ione:
            findresponse[0].total +
            findresponse[1].total +
            findresponse[2].total,
        });
      });

    //Version Tester Div distribution Active Password
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_tester_os_ap_div/";
    } else {
      var data_source_final = "get_dashboard_version_tester_os_ap_div/";
    }

    fetch(
      config.API +
        // "get_dashboard_version_tester_os_ap_div/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse[1].total);

        if (findresponse[0].total) {
          this.setState({
            ver_tester_ap_undefined_div: findresponse[0].total,
          });
        } else {
          this.setState({
            ver_tester_ap_undefined_div: 0,
          });
        }

        if (findresponse[1].total) {
          this.setState({
            ver_tester_ap_android_div: findresponse[1].total,
          });
        } else {
          this.setState({
            ver_tester_ap_android_div: 0,
          });
        }

        if (findresponse[2].total) {
          this.setState({
            ver_tester_ap_windows_div: findresponse[2].total,
          });
        } else {
          this.setState({
            ver_tester_ap_windows_div: 0,
          });
        }

        this.setState({
          ver_tester_ap_total_div:
            findresponse[0].total +
            findresponse[1].total +
            findresponse[2].total,
        });
      });

    //Version Tester iONE distribution Active Password
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_tester_os_ap_ione/";
    } else {
      var data_source_final = "get_dashboard_version_tester_os_ap_ione/";
    }

    fetch(
      config.API +
        // "get_dashboard_version_tester_os_ap_ione/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse[1].total);

        if (findresponse[0].total) {
          this.setState({
            ver_tester_ap_undefined_ione: findresponse[0].total,
          });
        } else {
          this.setState({
            ver_tester_ap_undefined_ione: 0,
          });
        }

        if (findresponse[1].total) {
          this.setState({
            ver_tester_ap_android_ione: findresponse[1].total,
          });
        } else {
          this.setState({
            ver_tester_ap_android_ione: 0,
          });
        }

        if (findresponse[2].total) {
          this.setState({
            ver_tester_ap_windows_ione: findresponse[2].total,
          });
        } else {
          this.setState({
            ver_tester_ap_windows_ione: 0,
          });
        }

        this.setState({
          ver_tester_ap_total_ione:
            findresponse[0].total +
            findresponse[1].total +
            findresponse[2].total,
        });
      });

    //Sum All user count
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_sum_active_users/";
    } else {
      var data_source_final = "get_dashboard_sum_active_users/";
    }

    fetch(
      config.API +
        // "get_dashboard_sum_active_users/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        this.setState({
          sum_ac_user_count: findresponse.diag_count,
        });
      });

    //Sum Active Password
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_sum_ap/";
    } else {
      var data_source_final = "get_dashboard_sum_ap/";
    }

    fetch(
      config.API +
        // "get_dashboard_sum_ap/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        this.setState({
          sum_ac_password: findresponse.ac_password,
          sum_exp_password: findresponse.exp_password,
        });
      });

    //Sum All Active Password
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_sum_all_ap/";
    } else {
      var data_source_final = "get_dashboard_sum_all_ap/";
    }

    fetch(
      config.API +
        // "get_dashboard_sum_all_ap/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        this.setState({
          sum_all_ac_password: findresponse.ac_password,
          sum_all_exp_password: findresponse.exp_password,
        });
        this.setState({
          sum_all_ap_total:
            findresponse.ac_password + findresponse.exp_password,
        });
      });

    //Sum OS Type
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_sum_os/";
    } else {
      var data_source_final = "get_dashboard_sum_os/";
    }

    fetch(
      config.API +
        // "get_dashboard_sum_os/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        if (findresponse[0].total) {
          this.setState({
            sum_os_undefined: findresponse[0].total,
          });
        } else {
          this.setState({
            sum_os_undefined: 0,
          });
        }

        if (findresponse[2].total) {
          this.setState({
            sum_os_windows: findresponse[2].total,
          });
        } else {
          this.setState({
            sum_os_windows: 0,
          });
        }

        if (findresponse[1].total) {
          this.setState({
            sum_os_android: findresponse[1].total,
          });
        } else {
          this.setState({
            sum_os_android: 0,
          });
        }
        this.setState({
          sum_os_total:
            findresponse[0].total +
            findresponse[1].total +
            findresponse[2].total,
          loading: false,
        });
      });
  }

  handleDiagAcUserBarChange(prod) {
    var days = prod.target.value;
    const selected_product = localStorage.getItem("sel_product");
    const user_language = localStorage.getItem("user_db_lang");
    const data_source = localStorage.getItem("data_source");
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_active_users/";
    } else {
      var data_source_final = "get_dashboard_active users/";
    }

    if (!selected_product) {
      var sel_product = "all";
    } else {
      var sel_product = selected_product;
    }
    fetch(
      config.API +
        // "get_dashboard_active_users/" +
        data_source_final +
        days +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        this.setState({
          diag_ac_user_count: findresponse.diag_count,
          diag_au_daysvalue: days,
        });
      });
  }

  handleDiagBarChange(prod) {
    var days = prod.target.value;
    const selected_product = localStorage.getItem("sel_product");
    const user_language = localStorage.getItem("user_db_lang");
    const data_source = localStorage.getItem("data_source");
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_diagnosis/";
    } else {
      var data_source_final = "get_dashboard_diagnosis/";
    }

    if (!selected_product) {
      var sel_product = "all";
    } else {
      var sel_product = selected_product;
    }
    fetch(
      config.API +
        // "get_dashboard_diagnosis/" +
        data_source_final +
        days +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        // console.log(findresponse);
        this.setState({
          diag_count: findresponse.diag_count,
          diag_daysvalue: days,
        });
      });
  }

  handleDiagBrandBarChange(prod) {
    var days = prod.target.value;
    const selected_product = localStorage.getItem("sel_product");
    const user_language = localStorage.getItem("user_db_lang");
    const data_source = localStorage.getItem("data_source");
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_diagnosis_brands/";
    } else {
      var data_source_final = "get_dashboard_diagnosis_brands/";
    }

    if (!selected_product) {
      var sel_product = "all";
    } else {
      var sel_product = selected_product;
    }
    fetch(
      config.API +
        // "get_dashboard_diagnosis_brands/" +
        data_source_final +
        days +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse);
        this.setState({
          diag_brand_list: findresponse.brands.b_list,
          diag_brand_item: findresponse.brands.b_items,
          diag_brands_daysvalue: days,
        });
      });
  }

  handleDiagModelBarChange(prod) {
    var days = prod.target.value;
    const selected_product = localStorage.getItem("sel_product");
    const user_language = localStorage.getItem("user_db_lang");
    const data_source = localStorage.getItem("data_source");
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_diagnosis_models/";
    } else {
      var data_source_final = "get_dashboard_diagnosis_models/";
    }

    if (!selected_product) {
      var sel_product = "all";
    } else {
      var sel_product = selected_product;
    }
    fetch(
      config.API +
        // "get_dashboard_diagnosis_models/" +
        data_source_final +
        days +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse);
        this.setState({
          diag_model_list: findresponse.models.b_list,
          diag_model_item: findresponse.models.b_items,
          diag_models_daysvalue: days,
        });
      });
  }

  handleDiagEcuBarChange(prod) {
    var days = prod.target.value;
    const selected_product = localStorage.getItem("sel_product");
    const user_language = localStorage.getItem("user_db_lang");
    const data_source = localStorage.getItem("data_source");
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_diagnosis_ecu/";
    } else {
      var data_source_final = "get_dashboard_diagnosis_ecu/";
    }

    if (!selected_product) {
      var sel_product = "all";
    } else {
      var sel_product = selected_product;
    }
    fetch(
      config.API +
        // "get_dashboard_diagnosis_ecu/" +
        data_source_final +
        days +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&lang=" +
        localStorage.getItem("lang") +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse);
        this.setState({
          diag_ecu_list: findresponse.models.b_list,
          diag_ecu_item: findresponse.models.b_items,
          diag_ecu_daysvalue: days,
        });
      });
  }

  handleDiagLangBarChange(prod) {
    var days = prod.target.value;
    const selected_product = localStorage.getItem("sel_product");
    const user_language = localStorage.getItem("user_db_lang");
    const data_source = localStorage.getItem("data_source");
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_diagnosis_lang/";
    } else {
      var data_source_final = "get_dashboard_diagnosis_lang/";
    }

    if (!selected_product) {
      var sel_product = "all";
    } else {
      var sel_product = selected_product;
    }
    fetch(
      config.API +
        // "get_dashboard_diagnosis_lang/" +
        data_source_final +
        days +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse);
        this.setState({
          diag_lang_list: findresponse.languages.b_list,
          diag_lang_item: findresponse.languages.b_items,
          diag_lang_daysvalue: days,
        });
      });
  }

  handleVerLangBarChange(prod) {
    var days = prod.target.value;
    const selected_product = localStorage.getItem("sel_product");
    const user_language = localStorage.getItem("user_db_lang");
    const data_source = localStorage.getItem("data_source");
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_lang/";
    } else {
      var data_source_final = "get_dashboard_version_lang/";
    }

    if (!selected_product) {
      var sel_product = "all";
    } else {
      var sel_product = selected_product;
    }
    //console.log(days);
    fetch(
      config.API +
        // "get_dashboard_version_lang/" +
        data_source_final +
        days +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse);
        this.setState({
          ver_lang_list: findresponse.languages.b_list,
          ver_lang_item: findresponse.languages.b_items,
          ver_lang_daysvalue: days,
        });
      });
  }

  handleVerApBarChange(prod) {
    var days = prod.target.value;
    const selected_product = localStorage.getItem("sel_product");
    const user_language = localStorage.getItem("user_db_lang");
    const data_source = localStorage.getItem("data_source");
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_ap/";
    } else {
      var data_source_final = "get_dashboard_version_ap/";
    }

    if (!selected_product) {
      var sel_product = "all";
    } else {
      var sel_product = selected_product;
    }
    fetch(
      config.API +
        // "get_dashboard_version_ap/" +
        data_source_final +
        days +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        this.setState({
          ver_ac_password: findresponse.ac_password,
          ver_exp_password: findresponse.exp_password,
          ver_ap_daysvalue: days,
        });
      });
  }

  handleDiagLocationBarChange(prod) {
    let diag_country_count;
    var days = prod.target.value;
    const selected_product = localStorage.getItem("sel_product");
    const user_language = localStorage.getItem("user_db_lang");
    const data_source = localStorage.getItem("data_source");
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_diagnosis/";
    } else {
      var data_source_final = "get_dashboard_diagnosis/";
    }

    if (!selected_product) {
      var sel_product = "all";
    } else {
      var sel_product = selected_product;
    }

    fetch(
      config.API +
        // "get_dashboard_diagnosis/" +
        data_source_final +
        days +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        diag_country_count = findresponse.diag_count;
      })
      .then(() => {
        if (data_source === "internal") {
          var data_source_final = "test_get_dashboard_diagnosis_location/";
        } else {
          var data_source_final = "get_dashboard_diagnosis_location/";
        }

        fetch(
          config.API +
            // "get_dashboard_diagnosis_location/" +
            data_source_final +
            days +
            "?company=Nexion&sel_product=" +
            sel_product +
            "&user_lang=" +
            user_language,
          {
            headers: {
              Nexion_API_Key: config.API_KEY,
            },
          }
        )
          .then((Response) => Response.json())
          .then((findresponse) => {
            var old_total_count = findresponse
              .map((item) => item.diagnosis_count)
              .reduce((prev, next) => prev + next, 0);

            let diag_undef = diag_country_count - old_total_count;

            let new_loc_array = {
              diagnosis_count: diag_undef,
              country_name: "Undefined",
            };
            findresponse.push(new_loc_array);

            var new_total_count = findresponse
              .map((item) => item.diagnosis_count)
              .reduce((prev, next) => prev + next);

            this.setState({
              diag_location_count: new_total_count,
              diag_map_daysvalue: days,
              diag_location_array: findresponse,
            });
          });
      });
  }

  handleDiagTesterBarChange(prod) {
    var days = prod.target.value;
    const selected_product = localStorage.getItem("sel_product");
    const user_language = localStorage.getItem("user_db_lang");
    const data_source = localStorage.getItem("data_source");
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_diagnosis_tester/";
    } else {
      var data_source_final = "get_dashboard_diagnosis_tester/";
    }

    if (!selected_product) {
      var sel_product = "all";
    } else {
      var sel_product = selected_product;
    }
    fetch(
      config.API +
        // "get_dashboard_diagnosis_tester/" +
        data_source_final +
        days +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        // console.log(findresponse);
        this.setState({
          diag_tester_list: findresponse.testers.t_list,
          diag_tester_item: findresponse.testers.t_items,
          diag_tester_daysvalue: days,
        });
      });
  }

  handleVerAcUserBarChange(prod) {
    var days = prod.target.value;
    const selected_product = localStorage.getItem("sel_product");
    const user_language = localStorage.getItem("user_db_lang");
    const data_source = localStorage.getItem("data_source");
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_active_users/";
    } else {
      var data_source_final = "get_dashboard_version_active_users/";
    }

    if (!selected_product) {
      var sel_product = "all";
    } else {
      var sel_product = selected_product;
    }
    fetch(
      config.API +
        // "get_dashboard_version_active_users/" +
        data_source_final +
        days +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        // console.log(findresponse);
        this.setState({
          ver_ac_user_count: findresponse.ver_count,
          ver_au_daysvalue: days,
        });
      });
  }

  handleVerBarChange(prod) {
    var days = prod.target.value;
    const selected_product = localStorage.getItem("sel_product");
    const user_language = localStorage.getItem("user_db_lang");
    const data_source = localStorage.getItem("data_source");
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_versions/";
    } else {
      var data_source_final = "get_dashboard_versions/";
    }

    if (!selected_product) {
      var sel_product = "all";
    } else {
      var sel_product = selected_product;
    }
    fetch(
      config.API +
        // "get_dashboard_versions/" +
        data_source_final +
        days +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        // console.log(findresponse);
        this.setState({
          ver_count: findresponse.ver_count,
          ver_daysvalue: days,
        });
      });
  }

  handleVerLocationBarChange(prod) {
    let ver_country_count;
    var days = prod.target.value;
    const selected_product = localStorage.getItem("sel_product");
    const user_language = localStorage.getItem("user_db_lang");
    const data_source = localStorage.getItem("data_source");
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_versions/";
    } else {
      var data_source_final = "get_dashboard_versions/";
    }

    if (!selected_product) {
      var sel_product = "all";
    } else {
      var sel_product = selected_product;
    }

    fetch(
      config.API +
        // "get_dashboard_versions/" +
        data_source_final +
        days +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        ver_country_count = findresponse.ver_count;
      })
      .then(() => {
        const data_source = localStorage.getItem("data_source");
        if (data_source === "internal") {
          var data_source_final = "test_get_dashboard_version_location/";
        } else {
          var data_source_final = "get_dashboard_version_location/";
        }

        fetch(
          config.API +
            // "get_dashboard_version_location/" +
            data_source_final +
            days +
            "?company=Nexion&sel_product=" +
            sel_product +
            "&user_lang=" +
            user_language,
          {
            headers: {
              Nexion_API_Key: config.API_KEY,
            },
          }
        )
          .then((Response) => Response.json())
          .then((findresponse) => {
            var old_total_count = findresponse
              .map((item) => item.diagnosis_count)
              .reduce((prev, next) => prev + next, 0);

            let ver_undef = ver_country_count - old_total_count;
            let new_loc_array = {
              diagnosis_count: ver_undef,
              country_name: "Undefined",
            };
            findresponse.push(new_loc_array);

            var new_total_count = findresponse
              .map((item) => item.diagnosis_count)
              .reduce((prev, next) => prev + next, 0);

            this.setState({
              ver_location_count: new_total_count,
              ver_map_daysvalue: days,
              ver_location_array: findresponse,
            });
          });
      });
  }

  handleVerTesterBarChange(prod) {
    var days = prod.target.value;
    const selected_product = localStorage.getItem("sel_product");
    const user_language = localStorage.getItem("user_db_lang");
    const data_source = localStorage.getItem("data_source");
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_tester/";
    } else {
      var data_source_final = "get_dashboard_version_tester/";
    }

    if (!selected_product) {
      var sel_product = "all";
    } else {
      var sel_product = selected_product;
    }
    fetch(
      config.API +
        // "get_dashboard_version_tester/" +
        data_source_final +
        days +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        // console.log(findresponse);
        this.setState({
          ver_tester_list: findresponse.testers.t_list,
          ver_tester_item: findresponse.testers.t_items,
          ver_tester_daysvalue: days,
        });
      });
  }

  handleVerTesterDisBarChange(prod) {
    var days = prod.target.value;
    const selected_product = localStorage.getItem("sel_product");
    const user_language = localStorage.getItem("user_db_lang");
    const data_source = localStorage.getItem("data_source");
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_tester_os_div/";
    } else {
      var data_source_final = "get_dashboard_version_tester_os_div/";
    }

    if (!selected_product) {
      var sel_product = "all";
    } else {
      var sel_product = selected_product;
    }
    fetch(
      config.API +
        // "get_dashboard_version_tester_os_div/" +
        data_source_final +
        days +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse[2].total);
        this.setState({
          ver_tester_d_daysvalue: days,
        });

        if (findresponse[0].total) {
          this.setState({
            ver_tester_undefined_div: findresponse[0].total,
          });
        } else {
          this.setState({
            ver_tester_undefined_div: 0,
          });
        }

        if (findresponse[1].total) {
          this.setState({
            ver_tester_android_div: findresponse[1].total,
          });
        } else {
          this.setState({
            ver_tester_android_div: 0,
          });
        }

        if (findresponse[2].total) {
          this.setState({
            ver_tester_windows_div: findresponse[2].total,
          });
        } else {
          this.setState({
            ver_tester_windows_div: 0,
          });
        }
        this.setState({
          ver_tester_total_div:
            findresponse[0].total +
            findresponse[1].total +
            findresponse[2].total,
        });
      });

    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_tester_os_ione/";
    } else {
      var data_source_final = "get_dashboard_version_tester_os_ione/";
    }

    fetch(
      config.API +
        // "get_dashboard_version_tester_os_ione/" +
        data_source_final +
        days +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse[2].total);
        this.setState({
          ver_tester_d_daysvalue: days,
        });

        if (findresponse[0].total) {
          this.setState({
            ver_tester_undefined_ione: findresponse[0].total,
          });
        } else {
          this.setState({
            ver_tester_undefined_ione: 0,
          });
        }

        if (findresponse[1].total) {
          this.setState({
            ver_tester_android_ione: findresponse[1].total,
          });
        } else {
          this.setState({
            ver_tester_android_ione: 0,
          });
        }

        if (findresponse[2].total) {
          this.setState({
            ver_tester_windows_ione: findresponse[2].total,
          });
        } else {
          this.setState({
            ver_tester_windows_ione: 0,
          });
        }
        this.setState({
          ver_tester_total_ione:
            findresponse[0].total +
            findresponse[1].total +
            findresponse[2].total,
        });
      });
  }

  // handleVerTesterIoneDisBarChange(prod) {
  //   var days = prod.target.value;
  //   fetch(
  //     config.API +
  //       "get_dashboard_version_tester_os_ione/" +
  //       days +
  //       "?company=Nexion",
  //     {
  //       headers: {
  //         Nexion_API_Key: config.API_KEY,
  //       },
  //     }
  //   )
  //     .then((Response) => Response.json())
  //     .then((findresponse) => {
  //       //console.log(findresponse[2].total);
  //       this.setState({
  //         ver_tester_d_daysvalue: days,
  //       });

  //       if (findresponse[0].total) {
  //         this.setState({
  //           ver_tester_undefined_ione: findresponse[0].total,
  //         });
  //       } else {
  //         this.setState({
  //           ver_tester_undefined_ione: 0,
  //         });
  //       }

  //       if (findresponse[1].total) {
  //         this.setState({
  //           ver_tester_android_ione: findresponse[1].total,
  //         });
  //       } else {
  //         this.setState({
  //           ver_tester_android_ione: 0,
  //         });
  //       }

  //       if (findresponse[2].total) {
  //         this.setState({
  //           ver_tester_windows_ione: findresponse[2].total,
  //         });
  //       } else {
  //         this.setState({
  //           ver_tester_windows_ione: 0,
  //         });
  //       }
  //       this.setState({
  //         ver_tester_total_ione:
  //           findresponse[0].total +
  //           findresponse[1].total +
  //           findresponse[2].total,
  //       });
  //     });
  // }

  handleVerTesterDisApBarChange(prod) {
    var days = prod.target.value;
    const selected_product = localStorage.getItem("sel_product");
    const user_language = localStorage.getItem("user_db_lang");
    const data_source = localStorage.getItem("data_source");
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_tester_os_ap_div/";
    } else {
      var data_source_final = "get_dashboard_version_tester_os_ap_div/";
    }

    if (!selected_product) {
      var sel_product = "all";
    } else {
      var sel_product = selected_product;
    }
    fetch(
      config.API +
        // "get_dashboard_version_tester_os_ap_div/" +
        data_source_final +
        days +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse[1].total);

        this.setState({
          ver_tester_ap_daysvalue: days,
        });

        if (findresponse[0].total) {
          this.setState({
            ver_tester_ap_undefined_div: findresponse[0].total,
          });
        } else {
          this.setState({
            ver_tester_ap_undefined_div: 0,
          });
        }

        if (findresponse[1].total) {
          this.setState({
            ver_tester_ap_android_div: findresponse[1].total,
          });
        } else {
          this.setState({
            ver_tester_ap_android_div: 0,
          });
        }

        if (findresponse[2].total) {
          this.setState({
            ver_tester_ap_windows_div: findresponse[2].total,
          });
        } else {
          this.setState({
            ver_tester_ap_windows_div: 0,
          });
        }

        this.setState({
          ver_tester_ap_total_div:
            findresponse[0].total +
            findresponse[1].total +
            findresponse[2].total,
        });
      });
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_tester_os_ap_ione/";
    } else {
      var data_source_final = "get_dashboard_version_tester_os_ap_ione/";
    }

    fetch(
      config.API +
        // "get_dashboard_version_tester_os_ap_ione/" +
        data_source_final +
        days +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse[1].total);

        this.setState({
          ver_tester_ap_daysvalue: days,
        });

        if (findresponse[0].total) {
          this.setState({
            ver_tester_ap_undefined_ione: findresponse[0].total,
          });
        } else {
          this.setState({
            ver_tester_ap_undefined_ione: 0,
          });
        }

        if (findresponse[1].total) {
          this.setState({
            ver_tester_ap_android_ione: findresponse[1].total,
          });
        } else {
          this.setState({
            ver_tester_ap_android_ione: 0,
          });
        }

        if (findresponse[2].total) {
          this.setState({
            ver_tester_ap_windows_ione: findresponse[2].total,
          });
        } else {
          this.setState({
            ver_tester_ap_windows_ione: 0,
          });
        }

        this.setState({
          ver_tester_ap_total_ione:
            findresponse[0].total +
            findresponse[1].total +
            findresponse[2].total,
        });
      });
  }

  // NEW Dashboard Section

  handleSumActUserBarChange(prod) {
    var days = prod.target.value;
    const selected_product = localStorage.getItem("sel_product");
    const user_language = localStorage.getItem("user_db_lang");
    const data_source = localStorage.getItem("data_source");
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_sum_active_users/";
    } else {
      var data_source_final = "get_dashboard_sum_active_users/";
    }

    if (!selected_product) {
      var sel_product = "all";
    } else {
      var sel_product = selected_product;
    }
    fetch(
      config.API +
        // "get_dashboard_sum_active_users/" +
        data_source_final +
        days +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse);
        this.setState({
          sum_ac_user_count: findresponse.diag_count,
          sum_au_daysvalue: days,
        });
      });
  }

  handleSumApBarChange(prod) {
    var days = prod.target.value;
    const selected_product = localStorage.getItem("sel_product");
    const user_language = localStorage.getItem("user_db_lang");
    const data_source = localStorage.getItem("data_source");
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_sum_ap/";
    } else {
      var data_source_final = "get_dashboard_sum_ap/";
    }

    if (!selected_product) {
      var sel_product = "all";
    } else {
      var sel_product = selected_product;
    }
    fetch(
      config.API +
        // "get_dashboard_sum_ap/" +
        data_source_final +
        days +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        this.setState({
          sum_ac_password: findresponse.ac_password,
          sum_exp_password: findresponse.exp_password,
          sum_ap_daysvalue: days,
        });
      });
  }

  handleSumAllApBarChange(prod) {
    var days = prod.target.value;
    const selected_product = localStorage.getItem("sel_product");
    const user_language = localStorage.getItem("user_db_lang");
    const data_source = localStorage.getItem("data_source");
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_sum_all_ap/";
    } else {
      var data_source_final = "get_dashboard_sum_all_ap/";
    }

    if (!selected_product) {
      var sel_product = "all";
    } else {
      var sel_product = selected_product;
    }
    fetch(
      config.API +
        // "get_dashboard_sum_all_ap/" +
        data_source_final +
        days +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        this.setState({
          sum_all_ac_password: findresponse.ac_password,
          sum_all_exp_password: findresponse.exp_password,
          sum_all_ap_daysvalue: days,
        });
        this.setState({
          sum_all_ap_total:
            findresponse.ac_password + findresponse.exp_password,
        });
      });
  }

  handleSumOSBarChange(prod) {
    var days = prod.target.value;
    const selected_product = localStorage.getItem("sel_product");
    const user_language = localStorage.getItem("user_db_lang");
    const data_source = localStorage.getItem("data_source");
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_sum_os/";
    } else {
      var data_source_final = "get_dashboard_sum_os/";
    }

    if (!selected_product) {
      var sel_product = "all";
    } else {
      var sel_product = selected_product;
    }
    fetch(
      config.API +
        // "get_dashboard_sum_os/" +
        data_source_final +
        days +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        this.setState({
          sum_os_daysvalue: days,
        });

        if (findresponse[0].total) {
          this.setState({
            sum_os_undefined: findresponse[0].total,
          });
        } else {
          this.setState({
            sum_os_undefined: 0,
          });
        }

        if (findresponse[2].total) {
          this.setState({
            sum_os_windows: findresponse[2].total,
          });
        } else {
          this.setState({
            sum_os_windows: 0,
          });
        }

        if (findresponse[1].total) {
          this.setState({
            sum_os_android: findresponse[1].total,
          });
        } else {
          this.setState({
            sum_os_android: 0,
          });
        }

        this.setState({
          sum_os_total:
            findresponse[0].total +
            findresponse[1].total +
            findresponse[2].total,
        });
      });
  }

  render() {
    const { t } = this.props;
    const data = {
      labels: this.state.diag_brand_list,
      datasets: [
        {
          label: "Brand",
          backgroundColor: "#016362",
          borderColor: "#016362",
          borderWidth: 1,
          hoverBackgroundColor: "#016362",
          hoverBorderColor: "#016362",
          data: this.state.diag_brand_item,
        },
      ],
    };

    const option = {
      tootlbar: {
        show: false,
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            var dataset = data.datasets[tooltipItem.datasetIndex];
            var currentValue = dataset.data[tooltipItem.index];
            return currentValue;
          },
          title: function (tooltipItem, data) {
            return data.labels[tooltipItem[0].index];
          },
        },
      },
    };

    const model_data = {
      labels: this.state.diag_model_list,
      datasets: [
        {
          label: "Models",
          backgroundColor: "#ffd200",
          borderColor: "#ffd200",
          borderWidth: 1,
          hoverBackgroundColor: "#ffd200",
          hoverBorderColor: "#ffd200",
          data: this.state.diag_model_item,
        },
      ],
    };

    const model_option = {
      tootlbar: {
        show: false,
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            var dataset = data.datasets[tooltipItem.datasetIndex];
            var currentValue = dataset.data[tooltipItem.index];
            return currentValue;
          },
          title: function (tooltipItem, data) {
            return data.labels[tooltipItem[0].index];
          },
        },
      },
      zoom: {
        enabled: true,
        type: "x",
        resetIcon: {
          offsetX: -10,
          offsetY: 0,
          fillColor: "#fff",
          strokeColor: "#37474F",
        },
        selection: {
          background: "#90CAF9",
          border: "#0D47A1",
        },
      },
    };

    const lang_data = {
      labels: this.state.diag_lang_list,
      datasets: [
        {
          label: t("homepage.languages"),
          backgroundColor: "#c3c852",
          borderColor: "#c3c852",
          borderWidth: 1,
          hoverBackgroundColor: "#c3c852",
          hoverBorderColor: "#c3c852",
          data: this.state.diag_lang_item,
        },
      ],
    };

    const lang_option = {
      tootlbar: {
        show: false,
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            var dataset = data.datasets[tooltipItem.datasetIndex];
            var currentValue = dataset.data[tooltipItem.index];
            return currentValue;
          },
          title: function (tooltipItem, data) {
            return data.labels[tooltipItem[0].index];
          },
        },
      },
    };

    const ver_lang_data = {
      labels: this.state.ver_lang_list,
      datasets: [
        {
          label: t("homepage.languages"),
          backgroundColor: "#016362",
          borderColor: "#016362",
          borderWidth: 1,
          hoverBackgroundColor: "#016362",
          hoverBorderColor: "#016362",
          data: this.state.ver_lang_item,
        },
      ],
    };

    const ver_lang_option = {
      tootlbar: {
        show: false,
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            var dataset = data.datasets[tooltipItem.datasetIndex];
            var currentValue = dataset.data[tooltipItem.index];
            return currentValue;
          },
          title: function (tooltipItem, data) {
            return data.labels[tooltipItem[0].index];
          },
        },
      },
    };

    const ecu_data = {
      labels: this.state.diag_ecu_list,
      datasets: [
        {
          label: "PLANT",
          backgroundColor: "#002c77",
          borderColor: "#002c77",
          borderWidth: 1,
          hoverBackgroundColor: "#002c77",
          hoverBorderColor: "#002c77",
          data: this.state.diag_ecu_item,
        },
      ],
    };

    const ecu_option = {
      tootlbar: {
        show: false,
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            var dataset = data.datasets[tooltipItem.datasetIndex];
            var currentValue = dataset.data[tooltipItem.index];
            return currentValue;
          },
          title: function (tooltipItem, data) {
            return data.labels[tooltipItem[0].index];
          },
        },
      },
    };

    const donut_options = {
      colors: ["#4EAABE", "#C3C852"],
      labels: ["Div.0", "iONE Cruiser"],
      dataLabels: {
        enabled: true,
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
            },
          },
        },
      },
      legend: {
        show: true,
        position: "top",
        horizontalAlign: "center",
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
              horizontalAlign: "center",
            },
          },
        },
      ],
      series: this.state.diag_tester_item,
    };

    const ver_donut_options = {
      colors: ["#4EAABE", "#C3C852"],
      labels: ["Div.0", "iONE Cruiser"],
      dataLabels: {
        enabled: true,
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
            },
          },
        },
      },
      legend: {
        show: true,
        position: "top",
        horizontalAlign: "center",
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
              horizontalAlign: "center",
            },
          },
        },
      ],
      series: this.state.ver_tester_item,
    };

    const ver_ap_options = {
      colors: ["#4EAABE", "#C3C852"],
      labels: [t("homepage.active_password"), t("homepage.expired_password")],
      dataLabels: {
        enabled: true,
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
            },
          },
        },
      },
      legend: {
        show: true,
        position: "top",
        horizontalAlign: "center",
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
              horizontalAlign: "center",
            },
          },
        },
      ],
      series: [this.state.ver_ac_password, this.state.ver_exp_password],
    };

    const tester_type_options = {
      colors: ["#C3C852", "#4EAABE", "#013363"],
      chart: {
        stacked: true,
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          columnWidth: "20%",
        },
      },
      grid: {
        borderColor: "#f8f8fa",
        row: {
          colors: ["transparent", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },

      xaxis: {
        categories: [
          "Magneti Marelli Div.0 (Total - " +
            this.state.ver_tester_total_div +
            ")",
          "Tecnomotor iONE Cruiser (Total - " +
            this.state.ver_tester_total_ione +
            ")",
        ],
        labels: {
          formatter: function (val) {
            return val;
          },
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: undefined,
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
      fill: {
        opacity: 1,
      },

      legend: {
        show: false,
        position: "top",
        horizontalAlign: "left",
        offsetX: 40,
      },
      series: [
        {
          name: "Undefined",
          data: [
            this.state.ver_tester_undefined_div,
            this.state.ver_tester_undefined_ione,
          ],
        },
        {
          name: "Windows",
          data: [
            this.state.ver_tester_windows_div,
            this.state.ver_tester_windows_ione,
          ],
        },
        {
          name: "Android",
          data: [
            this.state.ver_tester_android_div,
            this.state.ver_tester_android_ione,
          ],
        },
      ],
    };

    const ap_tester_type_options = {
      colors: ["#C3C852", "#4EAABE", "#013363"],
      chart: {
        stacked: true,
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          columnWidth: "20%",
        },
      },
      grid: {
        borderColor: "#f8f8fa",
        row: {
          colors: ["transparent", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },

      xaxis: {
        categories: [
          "Magneti Marelli Div.0 (Total - " +
            this.state.ver_tester_ap_total_div +
            ")",
          "Tecnomotor iONE Cruiser (Total - " +
            this.state.ver_tester_ap_total_ione +
            ")",
        ],
        labels: {
          formatter: function (val) {
            return val;
          },
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: undefined,
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
      fill: {
        opacity: 1,
      },

      legend: {
        show: false,
        position: "top",
        horizontalAlign: "left",
        offsetX: 40,
      },
      series: [
        {
          name: "Undefined",
          data: [
            this.state.ver_tester_ap_undefined_div,
            this.state.ver_tester_ap_undefined_ione,
          ],
        },
        {
          name: "Windows",
          data: [
            this.state.ver_tester_ap_windows_div,
            this.state.ver_tester_ap_windows_ione,
          ],
        },
        {
          name: "Android",
          data: [
            this.state.ver_tester_ap_android_div,
            this.state.ver_tester_ap_android_ione,
          ],
        },
      ],
    };

    // New Dashboard Section

    const sum_ap_options = {
      colors: ["#4EAABE", "#C3C852"],
      labels: [t("homepage.active_password"), t("homepage.expired_password")],
      dataLabels: {
        enabled: true,
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
            },
          },
        },
      },
      legend: {
        show: true,
        position: "top",
        horizontalAlign: "center",
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
              horizontalAlign: "center",
            },
          },
        },
      ],
      series: [this.state.sum_ac_password, this.state.sum_exp_password],
    };

    const sum_os_options = {
      colors: ["#C3C852", "#4EAABE", "#013363"],
      chart: {
        stacked: true,
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          columnWidth: "20%",
        },
      },
      grid: {
        borderColor: "#f8f8fa",
        row: {
          colors: ["transparent", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },

      xaxis: {
        categories: ["(Total - " + this.state.sum_os_total + ")"],
        labels: {
          formatter: function (val) {
            return val;
          },
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: undefined,
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
      fill: {
        opacity: 1,
      },

      legend: {
        show: false,
        position: "top",
        horizontalAlign: "left",
        offsetX: 40,
      },
      series: [
        {
          name: "Undefined",
          data: [this.state.sum_os_undefined],
        },
        {
          name: "Android",
          data: [this.state.sum_os_android],
        },
        {
          name: "Windows",
          data: [this.state.sum_os_windows],
        },
      ],
    };

    const sum_ap_all_options = {
      colors: ["#4EAABE", "#C3C852"],
      chart: {
        stacked: true,
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          columnWidth: "20%",
        },
      },
      grid: {
        borderColor: "#f8f8fa",
        row: {
          colors: ["transparent", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },

      xaxis: {
        categories: ["(Total - " + this.state.sum_all_ap_total + ")"],
        labels: {
          formatter: function (val) {
            return val;
          },
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: undefined,
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
      fill: {
        opacity: 1,
      },

      legend: {
        show: false,
        position: "top",
        horizontalAlign: "left",
        offsetX: 40,
      },
      series: [
        {
          name: t("homepage.active_password"),
          data: [this.state.sum_all_ac_password],
        },
        {
          name: t("homepage.expired_password"),
          data: [this.state.sum_all_exp_password],
        },
      ],
    };
    return (
      <ThemeContext.Consumer>
        {(value) => (
          <React.Fragment>
            <MetaTags>
              <title>Dashboard | Nexion Engineering Web Portal</title>
              <meta
                name="description"
                content="Diagnostic Portal For Technomotor and Magneti Marelli Instruments"
              />
            </MetaTags>
            <Sugar
              customLoading={this.state.loading}
              background="#016362"
              color={"#ffffff"}
            />
            <PulseLoader
              color={"#016362"}
              loading={this.state.tabledataloading}
              size={150}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
            <div className="container-fluid">
              <h5 className="stats_name">{t("homepage.summary")}</h5>
              <Row className="homepageFirstRow">
                <Col xl={6} sm={6}>
                  <Card className="dash_card_ver">
                    <CardBody>
                      <h4 className="card-title">
                        <i className="ion ion-ios-person text-nexion"></i>{" "}
                        {t("homepage.sum_ac_user_count")}
                      </h4>
                      <select
                        className="form-control"
                        onChange={this.handleSumActUserBarChange}
                        value={this.state.sum_au_daysvalue}
                      >
                        <option value="0">{t("topbar.overall")}</option>
                        <option value="14">
                          {t("topbar.last_14_days_daily")}
                        </option>
                        <option value="30">
                          {t("topbar.last_30_days_daily")}
                        </option>
                        <option value="90">{t("topbar.last_year")}</option>
                        <option value="180">{t("topbar.this_year")}</option>
                        <option value="365">{t("topbar.total")}</option>
                      </select>
                      <div className="text-center py-4">
                        <br></br>
                        <i class="ion ion-ios-person text-nexion text-center dashIcon"></i>
                        <br></br>
                        <h1 className="text-center text-nexion">
                          {this.state.sum_ac_user_count}
                        </h1>
                        {/* <p className="font-size-14 pt-1">{t("homepage.users")}</p> */}
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={6} sm={6}>
                  <Card className="dash_card_ver">
                    <CardBody>
                      <h4 className="card-title">
                        <i className="ion ion-ios-speedometer text-nexion"></i>{" "}
                        {t("homepage.sum_active_password")}
                      </h4>
                      <Row>
                        <Col xl={4}>
                          <select
                            className="form-control"
                            onChange={this.handleSumApBarChange}
                            value={this.state.sum_ap_daysvalue}
                          >
                            <option value="0">{t("topbar.overall")}</option>
                            <option value="14">
                              {t("topbar.last_14_days_daily")}
                            </option>
                            <option value="30">
                              {t("topbar.last_30_days_daily")}
                            </option>
                            <option value="90">{t("topbar.last_year")}</option>
                            <option value="180">{t("topbar.this_year")}</option>
                            <option value="365">{t("topbar.total")}</option>
                          </select>
                        </Col>
                        <Col xl={8}></Col>
                      </Row>
                      <br />
                      <br />
                      <br />
                      <React.Fragment>
                        <ReactApexChart
                          options={sum_ap_options}
                          series={sum_ap_options.series}
                          type="donut"
                          height="285"
                        />
                      </React.Fragment>
                      <br />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col xl={6} sm={6}>
                  <Card className="dash_card_ver">
                    <CardBody>
                      <h4 className="card-title">
                        <i className="ion ion-ios-speedometer text-nexion"></i>{" "}
                        {t("homepage.sum_all_active_password")}
                      </h4>
                      <Row>
                        <Col xl={4}>
                          <select
                            className="form-control"
                            onChange={this.handleSumAllApBarChange}
                            value={this.state.sum_all_ap_daysvalue}
                          >
                            <option value="0">{t("topbar.overall")}</option>
                            <option value="14">
                              {t("topbar.last_14_days_daily")}
                            </option>
                            <option value="30">
                              {t("topbar.last_30_days_daily")}
                            </option>
                            <option value="90">{t("topbar.last_year")}</option>
                            <option value="180">{t("topbar.this_year")}</option>
                            <option value="365">{t("topbar.total")}</option>
                          </select>
                        </Col>
                        <Col xl={8}></Col>
                      </Row>
                      <React.Fragment>
                        <ReactApexChart
                          options={sum_ap_all_options}
                          series={sum_ap_all_options.series}
                          type="bar"
                          height="290"
                        />
                      </React.Fragment>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={6} sm={6}>
                  <Card className="dash_card_ver">
                    <CardBody>
                      <h4 className="card-title">
                        <i className="ion ion-ios-speedometer text-nexion"></i>{" "}
                        {t("homepage.sum_os")}
                      </h4>
                      <Row>
                        <Col xl={4}>
                          <select
                            className="form-control"
                            onChange={this.handleSumOSBarChange}
                            value={this.state.sum_os_daysvalue}
                          >
                            <option value="0">{t("topbar.overall")}</option>
                            <option value="14">
                              {t("topbar.last_14_days_daily")}
                            </option>
                            <option value="30">
                              {t("topbar.last_30_days_daily")}
                            </option>
                            <option value="90">{t("topbar.last_year")}</option>
                            <option value="180">{t("topbar.this_year")}</option>
                            <option value="365">{t("topbar.total")}</option>
                          </select>
                        </Col>
                        <Col xl={8}></Col>
                      </Row>
                      <React.Fragment>
                        <ReactApexChart
                          options={sum_os_options}
                          series={sum_os_options.series}
                          type="bar"
                          height="290"
                        />
                      </React.Fragment>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <h5 className="stats_name">{t("homepage.DIAGNOSIS")}</h5>
              <Row className="homepageFirstRow">
                <Col xl={3} sm={6}>
                  <Card className="dash_card">
                    <CardBody>
                      <h4 className="card-title">
                        <i className="ion ion-ios-person text-nexion"></i>
                        {t("homepage.active_users")}
                      </h4>
                      <select
                        className="form-control"
                        onChange={this.handleDiagAcUserBarChange}
                        value={this.state.diag_au_daysvalue}
                      >
                        <option value="0">{t("topbar.overall")}</option>
                        <option value="14">
                          {t("topbar.last_14_days_daily")}
                        </option>
                        <option value="30">
                          {t("topbar.last_30_days_daily")}
                        </option>
                        <option value="90">{t("topbar.last_year")}</option>
                        <option value="180">{t("topbar.this_year")}</option>
                        <option value="365">{t("topbar.total")}</option>
                      </select>
                      {/* <p>OVERALL</p> */}

                      <div className="text-center py-4">
                        <br></br>
                        <i class="ion ion-ios-person text-nexion text-center dashIcon"></i>
                        <br></br>
                        <h1 className="text-center text-nexion">
                          {this.state.diag_ac_user_count}
                        </h1>
                        <p className="font-size-14 pt-1">
                          {t("homepage.users")}
                        </p>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={3} sm={6}>
                  <Card className="dash_card">
                    <CardBody>
                      <h4 className="card-title">
                        <i className="ion ion-md-medkit text-nexion"></i>{" "}
                        {t("homepage.diagnosis")}
                      </h4>
                      <select
                        className="form-control"
                        onChange={this.handleDiagBarChange}
                        value={this.state.diag_daysvalue}
                      >
                        <option value="0">{t("topbar.overall")}</option>
                        <option value="14">
                          {t("topbar.last_14_days_daily")}
                        </option>
                        <option value="30">
                          {t("topbar.last_30_days_daily")}
                        </option>
                        <option value="90">{t("topbar.last_year")}</option>
                        <option value="180">{t("topbar.this_year")}</option>
                        <option value="365">{t("topbar.total")}</option>
                      </select>

                      <div className="text-center py-4">
                        <br></br>
                        <i class="ion ion-md-medkit text-nexion text-center dashIcon"></i>
                        <br></br>
                        <h1 className="text-center text-nexion">
                          {this.state.diag_count}
                        </h1>
                        <p className="font-size-14 pt-1">
                          {t("homepage.diagnosis")}
                        </p>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={6}></Col>
              </Row>

              <Row>
                <Col xl={6} sm={6}>
                  <Card className="dash_card">
                    <CardBody>
                      <h4 className="card-title">
                        <i className="ion ion-ios-car text-nexion"></i>{" "}
                        {t("homepage.brands")}
                      </h4>
                      <Row>
                        <Col xl={4}>
                          <select
                            className="form-control"
                            onChange={this.handleDiagBrandBarChange}
                            value={this.state.diag_brands_daysvalue}
                          >
                            <option value="0">{t("topbar.overall")}</option>
                            <option value="14">
                              {t("topbar.last_14_days_daily")}
                            </option>
                            <option value="30">
                              {t("topbar.last_30_days_daily")}
                            </option>
                            <option value="90">{t("topbar.last_year")}</option>
                            <option value="180">{t("topbar.this_year")}</option>
                            <option value="365">{t("topbar.total")}</option>
                          </select>
                        </Col>
                        <Col xl={8}></Col>
                      </Row>

                      <React.Fragment>
                        <Bar
                          width={300}
                          height={138}
                          data={data}
                          options={{
                            ...option,
                            legend: {
                              labels: {
                                fontColor:
                                  value.theme === "Dark"
                                    ? "#bdbdbd"
                                    : "#5b626b",
                              },
                            },
                            scales: {
                              yAxes: [
                                {
                                  ticks: {
                                    beginAtZero: true,
                                    fontColor:
                                      value.theme === "Dark"
                                        ? "#bdbdbd"
                                        : "#5b626b",
                                  },
                                },
                              ],
                              xAxes: [
                                {
                                  ticks: {
                                    fontColor:
                                      value.theme === "Dark"
                                        ? "#bdbdbd"
                                        : "#5b626b",
                                  },
                                },
                              ],
                            },
                          }}
                        />
                      </React.Fragment>
                    </CardBody>
                  </Card>
                </Col>

                <Col xl={6} sm={6}>
                  <Card className="dash_card">
                    <CardBody>
                      <h4 className="card-title">
                        <i className="ion ion-ios-car text-nexion"></i>{" "}
                        {t("homepage.models")}
                      </h4>
                      <Row>
                        <Col xl={4}>
                          <select
                            className="form-control"
                            onChange={this.handleDiagModelBarChange}
                            value={this.state.diag_models_daysvalue}
                          >
                            <option value="0">{t("topbar.overall")}</option>
                            <option value="14">
                              {t("topbar.last_14_days_daily")}
                            </option>
                            <option value="30">
                              {t("topbar.last_30_days_daily")}
                            </option>
                            <option value="90">{t("topbar.last_year")}</option>
                            <option value="180">{t("topbar.this_year")}</option>
                            <option value="365">{t("topbar.total")}</option>
                          </select>
                        </Col>
                        <Col xl={8}></Col>
                      </Row>
                      <React.Fragment>
                        <Bar
                          width={300}
                          height={138}
                          data={model_data}
                          options={{
                            ...model_option,
                            legend: {
                              labels: {
                                fontColor:
                                  value.theme === "Dark"
                                    ? "#bdbdbd"
                                    : "#5b626b",
                              },
                            },
                            scales: {
                              yAxes: [
                                {
                                  ticks: {
                                    beginAtZero: true,
                                    fontColor:
                                      value.theme === "Dark"
                                        ? "#bdbdbd"
                                        : "#5b626b",
                                  },
                                },
                              ],
                              xAxes: [
                                {
                                  ticks: {
                                    fontColor:
                                      value.theme === "Dark"
                                        ? "#bdbdbd"
                                        : "#5b626b",
                                  },
                                },
                              ],
                            },
                          }}
                        />
                      </React.Fragment>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              <Row>
                <Col xl={6} sm={6}>
                  <Card className="dash_card">
                    <CardBody>
                      <h4 className="card-title">
                        <i className="ion ion-ios-car text-nexion"></i> PLANT
                      </h4>
                      <Row>
                        <Col xl={4}>
                          <select
                            className="form-control"
                            onChange={this.handleDiagEcuBarChange}
                            value={this.state.diag_ecu_daysvalue}
                          >
                            <option value="0">{t("topbar.overall")}</option>
                            <option value="14">
                              {t("topbar.last_14_days_daily")}
                            </option>
                            <option value="30">
                              {t("topbar.last_30_days_daily")}
                            </option>
                            <option value="90">{t("topbar.last_year")}</option>
                            <option value="180">{t("topbar.this_year")}</option>
                            <option value="365">{t("topbar.total")}</option>
                          </select>
                        </Col>
                        <Col xl={8}></Col>
                      </Row>

                      <React.Fragment>
                        <Bar
                          width={300}
                          height={138}
                          data={{
                            ...ecu_data,
                            ...{
                              datasets: [
                                {
                                  label: "PLANT",
                                  backgroundColor:
                                    value.theme === "Dark"
                                      ? "#f0ad4e"
                                      : "#002c77",
                                  borderColor: "#002c77",
                                  borderWidth: 1,
                                  hoverBackgroundColor:
                                    value.theme === "Dark"
                                      ? "#f0ad4e"
                                      : "#002c77",
                                  hoverBorderColor: "#002c77",
                                  data: this.state.diag_ecu_item,
                                },
                              ],
                            },
                          }}
                          options={{
                            ...ecu_option,
                            legend: {
                              labels: {
                                fontColor:
                                  value.theme === "Dark"
                                    ? "#bdbdbd"
                                    : "#5b626b",
                              },
                            },
                            scales: {
                              yAxes: [
                                {
                                  ticks: {
                                    beginAtZero: true,
                                    fontColor:
                                      value.theme === "Dark"
                                        ? "#bdbdbd"
                                        : "#5b626b",
                                  },
                                },
                              ],
                              xAxes: [
                                {
                                  ticks: {
                                    fontColor:
                                      value.theme === "Dark"
                                        ? "#bdbdbd"
                                        : "#5b626b",
                                  },
                                },
                              ],
                            },
                          }}
                        />
                      </React.Fragment>
                    </CardBody>
                  </Card>
                </Col>

                <Col xl={6} sm={6}>
                  <Card className="dash_card">
                    <CardBody>
                      <h4 className="card-title">
                        <i className="ion ion-ios-car text-nexion"></i>{" "}
                        {t("homepage.languages")}
                      </h4>
                      <Row>
                        <Col xl={4}>
                          <select
                            className="form-control"
                            onChange={this.handleDiagLangBarChange}
                            value={this.state.diag_lang_daysvalue}
                          >
                            <option value="0">{t("topbar.overall")}</option>
                            <option value="14">
                              {t("topbar.last_14_days_daily")}
                            </option>
                            <option value="30">
                              {t("topbar.last_30_days_daily")}
                            </option>
                            <option value="90">{t("topbar.last_year")}</option>
                            <option value="180">{t("topbar.this_year")}</option>
                            <option value="365">{t("topbar.total")}</option>
                          </select>
                        </Col>
                        <Col xl={8}></Col>
                      </Row>

                      <React.Fragment>
                        <Bar
                          width={300}
                          height={138}
                          data={lang_data}
                          options={{
                            ...lang_option,
                            legend: {
                              labels: {
                                fontColor:
                                  value.theme === "Dark"
                                    ? "#bdbdbd"
                                    : "#5b626b",
                              },
                            },
                            scales: {
                              yAxes: [
                                {
                                  ticks: {
                                    beginAtZero: true,
                                    fontColor:
                                      value.theme === "Dark"
                                        ? "#bdbdbd"
                                        : "#5b626b",
                                  },
                                },
                              ],
                              xAxes: [
                                {
                                  ticks: {
                                    fontColor:
                                      value.theme === "Dark"
                                        ? "#bdbdbd"
                                        : "#5b626b",
                                  },
                                },
                              ],
                            },
                          }}
                        />
                      </React.Fragment>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              <Row>
                <Col xl={6} sm={6}>
                  <Card className="dash_card">
                    <CardBody>
                      <h4 className="card-title">
                        <i className="ion ion-md-analytics text-nexion"></i>{" "}
                        {t("homepage.countries")}
                      </h4>
                      <Row>
                        <Col xl={4}>
                          <select
                            className="form-control"
                            onChange={this.handleDiagLocationBarChange}
                            value={this.state.diag_map_daysvalue}
                          >
                            <option value="0">{t("topbar.overall")}</option>
                            <option value="14">
                              {t("topbar.last_14_days_daily")}
                            </option>
                            <option value="30">
                              {t("topbar.last_30_days_daily")}
                            </option>
                            <option value="90">{t("topbar.last_year")}</option>
                            <option value="180">{t("topbar.this_year")}</option>
                            <option value="365">{t("topbar.total")}</option>
                          </select>
                        </Col>
                        <Col xl={8}></Col>
                      </Row>

                      <Row>
                        <Col xl={4}>
                          <br></br>
                          <p className="card-title-desc">
                            <b>
                              {/* diagnosis_location */}
                              {/* {this.state.diag_count} - {t("homepage.all_tests")} */}
                              {this.state.diag_location_count} -{" "}
                              {t("homepage.all_tests")}
                            </b>
                          </p>

                          <div className="">
                            {this.state.diag_location_array.map((item) => {
                              return (
                                <div className="mb-10" key={item.country_name}>
                                  <p style={countryLine}>
                                    <span style={countryName}>
                                      {item.country_name}
                                    </span>
                                    <span style={countryCount}>
                                      {item.diagnosis_count}
                                    </span>
                                  </p>
                                  <Progress
                                    style={progressBar}
                                    color="success"
                                    value={item.diagnosis_count}
                                  ></Progress>
                                </div>
                              );
                            })}
                          </div>
                        </Col>
                        <Col xl={8}>
                          <VectorMap
                            map={"continents_mill"}
                            // onRegionClick={this.handleClick} // gets the country code
                            backgroundColor="transparent"
                            // ref="map"
                            containerStyle={{
                              width: "100%",
                              height: "100%",
                            }}
                            regionStyle={{
                              initial: {
                                fill: "#e0e0e0",
                                stroke: "none",
                                "stroke-width": 0,
                                "stroke-opacity": 0,
                              },
                              hover: {
                                "fill-opacity": 0.8,
                                cursor: "pointer",
                              },
                              selected: {
                                fill: "#002C77", //what colour clicked country will be
                              },
                              selectedHover: {},
                            }}
                            series={{
                              regions: [
                                {
                                  values: {
                                    //here i need to add theme
                                    EU:
                                      value.theme === "Dark"
                                        ? "#4EAABE"
                                        : "#016362",
                                    US:
                                      value.theme === "Dark"
                                        ? "#4EAABE"
                                        : "#016362",
                                  },
                                },
                              ],
                            }}
                            containerClassName="map"
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>

                <Col xl={6} sm={6}>
                  <Card className="dash_card">
                    <CardBody>
                      <h4 className="card-title">
                        <i className="ion ion-ios-speedometer text-nexion"></i>{" "}
                        {t("homepage.tester_type")}
                      </h4>
                      <Row>
                        <Col xl={4}>
                          <select
                            className="form-control"
                            onChange={this.handleDiagTesterBarChange}
                            value={this.state.diag_tester_daysvalue}
                          >
                            <option value="0">{t("topbar.overall")}</option>
                            <option value="14">
                              {t("topbar.last_14_days_daily")}
                            </option>
                            <option value="30">
                              {t("topbar.last_30_days_daily")}
                            </option>
                            <option value="90">{t("topbar.last_year")}</option>
                            <option value="180">{t("topbar.this_year")}</option>
                            <option value="365">{t("topbar.total")}</option>
                          </select>
                        </Col>
                        <Col xl={8}></Col>
                      </Row>
                      <br />
                      <br />
                      <br />
                      <React.Fragment>
                        <ReactApexChart
                          options={donut_options}
                          series={donut_options.series}
                          type="donut"
                          height="285"
                        />
                      </React.Fragment>
                      <br />
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              <Row>
                <Col xl={6} sm={6}>
                  <Card className="dash_card_ver">
                    <CardBody>
                      <h4 className="card-title">
                        <i className="ion ion-ios-speedometer text-nexion"></i>{" "}
                        {t("homepage.tester_type_distribution_overall")}
                      </h4>
                      <Row>
                        <Col xl={4}>
                          <select
                            className="form-control"
                            onChange={this.handleVerTesterDisBarChange}
                            value={this.state.ver_tester_d_daysvalue}
                          >
                            <option value="0">{t("topbar.overall")}</option>
                            <option value="14">
                              {t("topbar.last_14_days_daily")}
                            </option>
                            <option value="30">
                              {t("topbar.last_30_days_daily")}
                            </option>
                            <option value="90">{t("topbar.last_year")}</option>
                            <option value="180">{t("topbar.this_year")}</option>
                            <option value="365">{t("topbar.total")}</option>
                          </select>
                        </Col>
                        <Col xl={8}></Col>
                      </Row>
                      <React.Fragment>
                        <ReactApexChart
                          options={tester_type_options}
                          series={tester_type_options.series}
                          type="bar"
                          height="290"
                        />
                      </React.Fragment>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={6} sm={6}>
                  <Card className="dash_card_ver">
                    <CardBody>
                      <h4 className="card-title">
                        <i className="ion ion-ios-speedometer text-nexion"></i>{" "}
                        {t(
                          "homepage.tester_type_distribution_with_active_password"
                        )}
                      </h4>
                      <Row>
                        <Col xl={4}>
                          <select
                            className="form-control"
                            onChange={this.handleVerTesterDisApBarChange}
                            value={this.state.ver_tester_ap_daysvalue}
                          >
                            <option value="0">{t("topbar.overall")}</option>
                            <option value="14">
                              {t("topbar.last_14_days_daily")}
                            </option>
                            <option value="30">
                              {t("topbar.last_30_days_daily")}
                            </option>
                            <option value="90">{t("topbar.last_year")}</option>
                            <option value="180">{t("topbar.this_year")}</option>
                            <option value="365">{t("topbar.total")}</option>
                          </select>
                        </Col>
                        <Col xl={8}></Col>
                      </Row>
                      <React.Fragment>
                        <ReactApexChart
                          options={ap_tester_type_options}
                          series={ap_tester_type_options.series}
                          type="bar"
                          height="290"
                        />
                      </React.Fragment>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              {/* <Row>
            <Col xl={6}>
                  <Card className="dash_card">
                    <CardBody>
                    <h4 className="card-title"><i className="ion ion-ios-speedometer text-nexion"></i> Tester Type distribution (Overall)</h4>
                    
                    <React.Fragment>
                <ReactApexChart options={tester_type_options} series={tester_type_options.series} type="bar" height="290" />
            </React.Fragment>
                    </CardBody>
                  </Card>
            </Col>
            <Col xl={6}>
                  <Card className="dash_card">
                    <CardBody>
                    <h4 className="card-title"><i className="ion ion-ios-speedometer text-nexion"></i> Tester Type distribution (With Active Password)</h4>
                    
                    <React.Fragment>
                <ReactApexChart options={tester_type_options} series={tester_type_options.series} type="bar" height="290" />
            </React.Fragment>
                    </CardBody>
                  </Card>
            </Col>
          </Row> */}

              <h5 className="stats_name">{t("homepage.VERSION")}</h5>
              <Row className="homepageFirstRow">
                <Col xl={3} sm={6}>
                  <Card className="dash_card_ver">
                    <CardBody>
                      <h4 className="card-title">
                        <i className="ion ion-ios-person text-nexion"></i>{" "}
                        {t("homepage.ver_active_users")}
                      </h4>
                      <select
                        className="form-control"
                        onChange={this.handleVerAcUserBarChange}
                        value={this.state.ver_au_daysvalue}
                      >
                        <option value="0">{t("topbar.overall")}</option>
                        <option value="14">
                          {t("topbar.last_14_days_daily")}
                        </option>
                        <option value="30">
                          {t("topbar.last_30_days_daily")}
                        </option>
                        <option value="90">{t("topbar.last_year")}</option>
                        <option value="180">{t("topbar.this_year")}</option>
                        <option value="365">{t("topbar.total")}</option>
                      </select>
                      <div className="text-center py-4">
                        <br></br>
                        <i class="ion ion-ios-person text-nexion text-center dashIcon"></i>
                        <br></br>
                        <h1 className="text-center text-nexion">
                          {this.state.ver_ac_user_count}
                        </h1>
                        {/* <p className="font-size-14 pt-1">{t("homepage.users")}</p> */}
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={3} sm={6}>
                  <Card className="dash_card_ver">
                    <CardBody>
                      <h4 className="card-title">
                        <i className="ion ion-ios-list text-nexion"></i>{" "}
                        {t("homepage.dash_version")}
                      </h4>
                      <select
                        className="form-control"
                        onChange={this.handleVerBarChange}
                        value={this.state.ver_daysvalue}
                      >
                        <option value="0">{t("topbar.overall")}</option>
                        <option value="14">
                          {t("topbar.last_14_days_daily")}
                        </option>
                        <option value="30">
                          {t("topbar.last_30_days_daily")}
                        </option>
                        <option value="90">{t("topbar.last_year")}</option>
                        <option value="180">{t("topbar.this_year")}</option>
                        <option value="365">{t("topbar.total")}</option>
                      </select>
                      <div className="text-center py-4">
                        <br></br>
                        <i class="ion ion-ios-download text-nexion text-center dashIcon"></i>
                        <br></br>
                        <h1 className="text-center text-nexion">
                          {this.state.ver_count}
                        </h1>
                        {/* <p className="font-size-14 pt-1">{t("homepage.version")}</p> */}
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={6} sm={6}></Col>
              </Row>
              <Row>
                <Col xl={6} sm={6}>
                  <Card className="dash_card_ver">
                    <CardBody>
                      <h4 className="card-title">
                        <i className="ion ion-ios-speedometer text-nexion"></i>{" "}
                        {t("homepage.active_password")}
                      </h4>
                      <Row>
                        <Col xl={4}>
                          <select
                            className="form-control"
                            onChange={this.handleVerApBarChange}
                            value={this.state.ver_ap_daysvalue}
                          >
                            <option value="0">{t("topbar.overall")}</option>
                            <option value="14">
                              {t("topbar.last_14_days_daily")}
                            </option>
                            <option value="30">
                              {t("topbar.last_30_days_daily")}
                            </option>
                            <option value="90">{t("topbar.last_year")}</option>
                            <option value="180">{t("topbar.this_year")}</option>
                            <option value="365">{t("topbar.total")}</option>
                          </select>
                        </Col>
                        <Col xl={8}></Col>
                      </Row>
                      <br />
                      <br />
                      <br />
                      <React.Fragment>
                        <ReactApexChart
                          options={ver_ap_options}
                          series={ver_ap_options.series}
                          type="donut"
                          height="285"
                        />
                      </React.Fragment>
                      <br />
                    </CardBody>
                  </Card>
                </Col>

                <Col xl={6} sm={6}>
                  <Card className="dash_card_ver">
                    <CardBody>
                      <h4 className="card-title">
                        <i className="ion ion-ios-car text-nexion"></i>{" "}
                        {t("homepage.languages")}
                      </h4>
                      <Row>
                        <Col xl={4}>
                          <select
                            className="form-control"
                            onChange={this.handleVerLangBarChange}
                            value={this.state.ver_lang_daysvalue}
                          >
                            <option value="0">{t("topbar.overall")}</option>
                            <option value="14">
                              {t("topbar.last_14_days_daily")}
                            </option>
                            <option value="30">
                              {t("topbar.last_30_days_daily")}
                            </option>
                            <option value="90">{t("topbar.last_year")}</option>
                            <option value="180">{t("topbar.this_year")}</option>
                            <option value="365">{t("topbar.total")}</option>
                          </select>
                        </Col>
                        <Col xl={8}></Col>
                      </Row>

                      <React.Fragment>
                        <Bar
                          width={300}
                          height={138}
                          data={ver_lang_data}
                          options={{
                            ...ver_lang_option,
                            legend: {
                              labels: {
                                fontColor:
                                  value.theme === "Dark"
                                    ? "#bdbdbd"
                                    : "#5b626b",
                              },
                            },
                            scales: {
                              yAxes: [
                                {
                                  ticks: {
                                    beginAtZero: true,
                                    fontColor:
                                      value.theme === "Dark"
                                        ? "#bdbdbd"
                                        : "#5b626b",
                                  },
                                },
                              ],
                              xAxes: [
                                {
                                  ticks: {
                                    fontColor:
                                      value.theme === "Dark"
                                        ? "#bdbdbd"
                                        : "#5b626b",
                                  },
                                },
                              ],
                            },
                          }}
                        />
                      </React.Fragment>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col xl={6} sm={6}>
                  <Card className="dash_card_ver">
                    <CardBody>
                      <h4 className="card-title">
                        <i className="ion ion-md-analytics text-nexion"></i>{" "}
                        {t("homepage.countries")}
                      </h4>
                      <Row>
                        <Col xl={4}>
                          <select
                            className="form-control"
                            onChange={this.handleVerLocationBarChange}
                            value={this.state.ver_map_daysvalue}
                          >
                            <option value="0">{t("topbar.overall")}</option>
                            <option value="14">
                              {t("topbar.last_14_days_daily")}
                            </option>
                            <option value="30">
                              {t("topbar.last_30_days_daily")}
                            </option>
                            <option value="90">{t("topbar.last_year")}</option>
                            <option value="180">{t("topbar.this_year")}</option>
                            <option value="365">{t("topbar.total")}</option>
                          </select>
                        </Col>
                        <Col xl={8}></Col>
                      </Row>
                      <Row>
                        <Col xl={4}>
                          <br></br>
                          <p className="card-title-desc">
                            <b>
                              {this.state.ver_location_count} -{" "}
                              {t("homepage.all_tests")}
                            </b>
                          </p>

                          <div className="">
                            {this.state.ver_location_array.map((item) => {
                              return (
                                <div className="mb-10" key={item.country_name}>
                                  <p style={countryLine}>
                                    <span style={countryName}>
                                      {item.country_name}
                                    </span>
                                    <span style={countryCount}>
                                      {item.diagnosis_count}
                                    </span>
                                  </p>
                                  <Progress
                                    style={progressBar}
                                    color="success"
                                    value={item.diagnosis_count}
                                  ></Progress>
                                </div>
                              );
                            })}
                          </div>
                        </Col>
                        <Col xl={8}>
                          <VectorMap
                            map={"continents_mill"}
                            // onRegionClick={this.handleClick} // gets the country code
                            backgroundColor="transparent"
                            // ref="map"
                            containerStyle={{
                              width: "100%",
                              height: "100%",
                            }}
                            regionStyle={{
                              initial: {
                                fill: "#e0e0e0",
                                stroke: "none",
                                "stroke-width": 0,
                                "stroke-opacity": 0,
                              },
                              hover: {
                                "fill-opacity": 0.8,
                                cursor: "pointer",
                              },
                              selected: {
                                fill: "#002C77", //what colour clicked country will be
                              },
                              selectedHover: {},
                            }}
                            series={{
                              regions: [
                                {
                                  values: {
                                    EU:
                                      value.theme === "Dark"
                                        ? "#4EAABE"
                                        : "#016362",
                                    US:
                                      value.theme === "Dark"
                                        ? "#4EAABE"
                                        : "#016362",
                                  },
                                },
                              ],
                            }}
                            containerClassName="map"
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>

                <Col xl={6} sm={6}>
                  <Card className="dash_card_ver">
                    <CardBody>
                      <h4 className="card-title">
                        <i className="ion ion-ios-speedometer text-nexion"></i>{" "}
                        {t("homepage.tester_type_ver")}
                      </h4>
                      <Row>
                        <Col xl={4}>
                          <select
                            className="form-control"
                            onChange={this.handleVerTesterBarChange}
                            value={this.state.ver_tester_daysvalue}
                          >
                            <option value="0">{t("topbar.overall")}</option>
                            <option value="14">
                              {t("topbar.last_14_days_daily")}
                            </option>
                            <option value="30">
                              {t("topbar.last_30_days_daily")}
                            </option>
                            <option value="90">{t("topbar.last_year")}</option>
                            <option value="180">{t("topbar.this_year")}</option>
                            <option value="365">{t("topbar.total")}</option>
                          </select>
                        </Col>
                        <Col xl={8}></Col>
                      </Row>
                      <br />
                      <br />
                      <br />
                      <React.Fragment>
                        <ReactApexChart
                          options={ver_donut_options}
                          series={ver_donut_options.series}
                          type="donut"
                          height="285"
                        />
                      </React.Fragment>
                      <br />
                    </CardBody>
                    <br />
                    <br />
                    <div className="d-print-none">
                      <div className="float-right">
                        <Link
                          to="dashboard_report"
                          target="_blank"
                          className="btn btn-mm waves-effect waves-light"
                        >
                          <i className="fa fa-print"> Visualizza Report</i>
                        </Link>
                      </div>
                    </div>
                  </Card>
                </Col>
              </Row>

              {/* <Row>
            <Col xl={6}>
              <Card className="dash_card_ver">
                <CardBody>
                  <h4 className="card-title">
                    <i className="ion ion-ios-speedometer text-nexion"></i>{" "}
                    {t("homepage.tester_type_distribution_overall")}
                  </h4>
                  <Row>
                    <Col xl={3}>
                      <select
                        className="form-control"
                        onChange={this.handleVerTesterDisBarChange}
                        value={this.state.ver_tester_d_daysvalue}
                      >
                        <option value="0">OVERALL</option>
                        <option value="14">14 Days</option>
                        <option value="30">30 Days</option>
                        <option value="90">90 Days</option>
                        <option value="180">180 Days</option>
                        <option value="365">365 Days</option>
                      </select>
                    </Col>
                    <Col xl={9}></Col>
                  </Row>
                  <React.Fragment>
                    <ReactApexChart
                      options={tester_type_options}
                      series={tester_type_options.series}
                      type="bar"
                      height="290"
                    />
                  </React.Fragment>
                </CardBody>
              </Card>
            </Col>
            <Col xl={6}>
              <Card className="dash_card_ver">
                <CardBody>
                  <h4 className="card-title">
                    <i className="ion ion-ios-speedometer text-nexion"></i>{" "}
                    {t(
                      "homepage.tester_type_distribution_with_active_password"
                    )}
                  </h4>
                  <Row>
                    <Col xl={3}>
                      <select
                        className="form-control"
                        onChange={this.handleVerTesterDisApBarChange}
                        value={this.state.ver_tester_ap_daysvalue}
                      >
                        <option value="0">OVERALL</option>
                        <option value="14">14 Days</option>
                        <option value="30">30 Days</option>
                        <option value="90">90 Days</option>
                        <option value="180">180 Days</option>
                        <option value="365">365 Days</option>
                      </select>
                    </Col>
                    <Col xl={9}></Col>
                  </Row>
                  <React.Fragment>
                    <ReactApexChart
                      options={ap_tester_type_options}
                      series={ap_tester_type_options.series}
                      type="bar"
                      height="290"
                    />
                  </React.Fragment>
                </CardBody>
              </Card>
            </Col>
          </Row> */}
            </div>
          </React.Fragment>
        )}
      </ThemeContext.Consumer>
    );
  }
}

export default withTranslation()(Dashboard);
